import { filters, Graphics } from 'pixi.js';
import { ModalContainerController } from '../../Controllers/Modals/ModalContainerController';
import { ViewManager } from '../ViewManager';
import { ModalsNames } from './ModalsList';
import gsap from 'gsap';
import {GameModel} from "../../Models/GameModel";
import {ModelEvents} from "@denishussar/html5-game-engine";
import { GameEvent } from '../../Constants/GameEvent';


//todo: check interactivity of hidden children in view

export class ModalsManager extends ViewManager {
    private _blur: filters.BlurFilter;

    private _views: any[] = [];

    private _lastKey: string | undefined;

    private _width: number;
    private _height: number;
    private _scale: number;

    private _overlayShowingTime: number = 0.15;

    private _model: GameModel;
    private _modelEvents: ModelEvents;

    constructor(
        view: ModalContainerController,
        model: GameModel,
        events: ModelEvents,
    ) {
        super(view);
        new ModalsNames();

        this._views = [];

        this._model = model;
        this._modelEvents = events;

        this._blur = new filters.BlurFilter(2, 1, 1, null);
        this._blur.passes = 2;
    }

    async addView2Pool(key: string, controller: any, options: object, model: any): Promise<void> {
        this.view.visible = false;
        return super.addView2Pool(key, controller, options, model).then(() => {
            this.view.visible = true;
        });
    }

    async show(key: string, options: any = {}): Promise<void> {
        return new Promise(resolve => {
            this._views.forEach(v => {
                v.display.interactiveChildren = false;
                //v.display.filters = [this._blur];
            });
            super.show(key);

            const view = this.view.$childControllers.get(key);

            view['_options'] = options;
            view['options'] = options;
            view['key'] = key;

            if (view['init']) {
                view['init']();
            }

            this._views.push(view);

            this._modelEvents.dispatch(this._model, 'changeModal', 'show', key, this._views.length > 0);

            if ('withoutEvent' in options && options.withoutEvent) {
                //
            } else {
                this._modelEvents.dispatch(this._model, GameEvent.popupOpen, { popupName: key });
            }

            if (view) {
                const overlay = new Graphics();
                overlay.name = 'overlay';
                overlay.alpha = 0;
                overlay.interactive = true;
                view.display.addChildAt(overlay, 0);

                gsap.killTweensOf(overlay);
                gsap.to(overlay, this._overlayShowingTime, { alpha: 1 });

                this.resize();
            }

            resolve();
        });
    }

    async hide(key: string | undefined = this.currentView ? this.currentView.key : undefined): Promise<void> {
        return new Promise(resolve => {
            if (!this.history.length) {
                this._views.forEach(v => {
                    v.display.interactiveChildren = true;
                    //v.display.filters = [];
                });
            }

            super.hide(key);

            const view = this.view.$childControllers.get(key);
            this._views.splice(this._views.indexOf(view), 1);

            this._modelEvents.dispatch(this._model, 'changeModal', 'hide', key, this._views.length > 0);

            if (view['release']) {
                view['release']();
            }

            if (view) {
                const overlay = view.display.getChildByName('overlay');
                if (overlay) {
                    view.display.filters = [];

                    overlay.interactive = false;

                    gsap.killTweensOf(overlay);
                    gsap.to(overlay, this._overlayShowingTime, {
                        alpha: 0, onComplete: () => {
                            if (view.display.children.includes(overlay)) {
                                view.display.removeChild(overlay);
                            }
                            this.resize();
                            resolve();
                        },
                    });
                }
            }
        });
    }

    resize(width: number = this._width, height: number = this._height, scale: number = this._scale): void {
        this._width = width;
        this._height = height;
        this._scale = scale;

        //@ts-ignore
        this._views.forEach(v => {
            const overlay = v.display.getChildByName('overlay');
            if (overlay) {
                overlay.clear();
                overlay.beginFill(0x000000, 0.75);
                overlay.drawRect(-width / 2 / scale, -height / 2 / scale, width / scale, height / scale);
                overlay.endFill();
            }
        });
    }

    hasView(name: string): boolean {
        return this._views.includes(this.view.$childControllers.get(name));
    }

    getCurrentKey(): string | undefined {
        return this._views.length ? this._views[this._views.length - 1].key : undefined;
    }
}
